import { toast } from 'react-toastify';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Typography } from '@mui/material';
import { useState } from 'react';

interface Props {
    label?: string;
    text: string;
}

export default function CopyToClipboardButton({ label, text }: Props) {
    const [buttonLabel, setButtonLabel] = useState(label || text);

    const onCopy = () => {
        setButtonLabel('Copied!');
        const timer = setTimeout(() => {
            setButtonLabel(label || text);
        }, 2500);
        return () => clearTimeout(timer);
    };

    return (
        <Button
            endIcon={buttonLabel === 'Copied!' ? <CheckOutlined /> : <ContentCopyIcon />}
            onClick={(e) => {
                navigator.clipboard.writeText(text);
                e.preventDefault();
                e.stopPropagation();
                toast.info(`text copied: ${text}`);
                onCopy();
            }}
            // style={{ color: 'rgba(0, 0, 0, 0.87)' }}
            sx={{ minWidth: '9em', textTransform: 'none' }}
            variant="outlined"
        >
            <Typography>{buttonLabel}</Typography>
        </Button>
    );
}
